module.exports = __webpack_public_path__ + "img/icon_site_detail.4f1a0c18.png";